import { render, staticRenderFns } from "./TaxInput.vue?vue&type=template&id=0d3a3c18&scoped=true&"
import script from "./TaxInput.vue?vue&type=script&lang=js&"
export * from "./TaxInput.vue?vue&type=script&lang=js&"
import style0 from "./TaxInput.vue?vue&type=style&index=0&id=0d3a3c18&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d3a3c18",
  null
  
)

export default component.exports